export default "__VITE_ASSET__DyaXW3Ho__"